/**
 * The UI entry point.
 *
 * REAL REACT AND THE SHARED PROVIDER. This rendered with preact's own `render` and imported
 * three stylesheets from `@create-figma-plugin/ui`, because the screens were built on that
 * kit. They are the shared Chakra flow now, so the kit, its CSS and the preact/compat layer
 * underneath all go with it.
 *
 * `syncTheme` goes too, and that one deserves a note. It existed because this UI is framed
 * cross-origin, so Figma injects no `--figma-color-*` variables for the kit to resolve
 * against. The shared theme does not read those variables at all — it defines its own palette
 * — so there is nothing left to synchronise.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, UiProvider, installGlobalErrorHandlers } from '@figma-importers/ui';
import App from './App';

const APP_NAME = 'image-to-design';

// Capture uncaught errors and unhandled rejections before the first render, so a failure
// during startup is reported rather than lost.
installGlobalErrorHandlers({ app: APP_NAME });

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <UiProvider>
        <ErrorBoundary app={APP_NAME}>
          <App />
        </ErrorBoundary>
      </UiProvider>
    </StrictMode>,
  );
}
